import * as API from './apiBase';

let baseList = {
    GetUserManualDetail: 'api/InvoiceNew/GetUserManualDetail',
}

/*用户手册详情 */
export const GetUserManualDetail = () => {
    return API.POST(baseList.GetUserManualDetail, {})
};
